import {
  ChakraBox,
  ChakraFlex,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';

const TOP_LEVEL_ID = 'inquiry-drawer-header';

interface InquiryDrawerHeaderProps {
  isDisabled?: boolean;
  isLoading: boolean;
  onSave: () => void;
  title: string;
}

const InquiryDrawerHeader = ({
  isDisabled,
  isLoading,
  onSave,
  title,
}: InquiryDrawerHeaderProps) => {
  return (
    <ChakraFlex
      alignItems="center"
      id={TOP_LEVEL_ID}
      justifyContent="space-between"
      paddingY="3px"
    >
      <Text color="neutral.primary" id={`${TOP_LEVEL_ID}__title`} variant="h4">
        {title}
      </Text>
      <ChakraBox marginRight="44px">
        <FireflyButton
          id={`${TOP_LEVEL_ID}__save`}
          isDisabled={isDisabled}
          isLoading={isLoading}
          leftIcon={FAIconName.checkRegular}
          onClick={onSave}
        >
          Save
        </FireflyButton>
      </ChakraBox>
    </ChakraFlex>
  );
};

export default InquiryDrawerHeader;
